export enum SmartSavers
{
  StopTimer = 'stopTimer',
  Hint = 'hint',
  CutIncorrect = 'cutIncorrect',
  Skip = 'skip'
}
